import { render, staticRenderFns } from "./space.vue?vue&type=template&id=004645cc&scoped=true"
import script from "./space.vue?vue&type=script&lang=js"
export * from "./space.vue?vue&type=script&lang=js"
import style0 from "./space.vue?vue&type=style&index=0&id=004645cc&prod&scoped=true&lang=css"
import style1 from "./space.vue?vue&type=style&index=1&id=004645cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004645cc",
  null
  
)

export default component.exports